import React, { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const SessionHandler = () => {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BASE_URL;
  const [countdown, setCountdown] = useState(120); // Countdown timer in seconds
  const [showPopup, setShowPopup] = useState(false); // Popup visibility
  const [popupVisible, setPopupVisible] = useState(false); // Popup visibility state

  // Callback to handle when user becomes idle
  const onIdle = () => {
    console.log("User is idle"); // Debugging

    setShowPopup(true); // Show the timeout popup
  };

  // Callback to handle when user becomes active
  const onActive = () => {
    console.log("User is active"); // Debugging

    // Do not hide the popup on user activity; only hide on button click.
  };

  // Countdown timer logic
  useEffect(() => {
    console.log("showPopup", showPopup); // Debugging
    let interval;
    if (showPopup && countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showPopup, countdown]);

  // Handle session expiration
  useEffect(() => {
    console.log("Countdown:", countdown); // Debugging
    if (countdown === 0) {
      setShowPopup(false);
      setPopupVisible(false);
      handleSessionExpired(); // Trigger session expiration logic directly
    }
  }, [countdown]);

  ////kill the session on server once user become idle

  const manageSession = async (get) => {
    try {
      const response = await fetch(`${API_URL}sessionSetting.php`, {
        method: "POST",
        body: JSON.stringify({
          type: get,
        }),
      });
      const data = await response.json();
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };

  ////////////////////end kill session//////////////////////
  // Method that handles session expiration (inside the component itself)
  const handleSessionExpired = () => {
    // Redirect to login page here
    manageSession("killSession");
    // Clear the cookie
    Cookies.remove("username");
    sessionStorage.clear();
    navigate("/login");
  };

  // Reset the countdown when the session is continued
  const handleContinueSession = () => {
    manageSession("continueSession");
    setCountdown(120); // Reset countdown to 10 seconds
    setPopupVisible(false); // Hide the popup
    setShowPopup(false); // Hide the popup
  };

  // End session and trigger expiration
  const handleEndSession = () => {
    handleSessionExpired(); // Trigger session expiration logic directly
  };

  // Initialize idle timer with a 10-second timeout for demo purposes
  const { start, reset, pause, resume, isIdle } = useIdleTimer({
    timeout: 7080 * 1000, // Timeout duration of 1 hour 58 minutes (7080 seconds)
    // timeout: 60 * 1000,
    onIdle,
    onActive,
    debounce: 500,
  });

  return (
    <>
      {/* Session Timeout Popup */}
      {showPopup && (
        <div
          style={{
            display: "block",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
            width: "360px", // Fixed width for the popup
          }}
        >
          <div style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}>
            Your session is about to expire
          </div>
          <p style={{ fontSize: "14px", color: "#555", marginTop: "10px" }}>
            Your session will expire in {countdown} seconds.
          </p>
          <div
            style={{
              width: "100%", // Ensure it doesn't exceed the popup width
              height: "20px",
              backgroundColor: "#f0f0f0",
              borderRadius: "10px",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                width: `${(countdown / 120) * 100}%`, // Adjust the progress bar width based on the countdown
                height: "100%",
                backgroundColor: "#007bff",
                borderRadius: "10px",
              }}
            ></div>
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <button
              onClick={handleEndSession}
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              End Session
            </button>
            <button
              onClick={handleContinueSession}
              style={{
                padding: "10px 20px",
                backgroundColor: "#4caf50",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Continue Session
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SessionHandler;
